export const PERMISSION_ROUTES = [
    { permission: 'orders.manage', path: '/order-management' },
    { permission: 'orders.view', path: '/order-management' },
    { permission: 'orders.notes', path: '/order-management' },
    { permission: 'payments.manage', path: '/payment-requests' },
    { permission: 'payments.verify', path: '/payment-requests' },
    { permission: 'customers.manage', path: '/customer-management' },
    { permission: 'customers.view', path: '/customer-management' },
    { permission: 'products.manage', path: '/product-management' },
    { permission: 'categories.manage', path: '/category-management' },
    { permission: 'manufacturers.manage', path: '/mfr-management' },
    { permission: 'users.manage', path: '/user-management' },
    { permission: 'roles.manage', path: '/role-management' },
    { permission: 'reports.export', path: '/order-management' },
    { permission: 'vendors.manage', path: '/vendor-management' },
];

export function getTeamMemberDefaultRoute() {
    const roles = JSON.parse(localStorage.getItem('userRoles') || '[]');
    if (roles.includes('admin')) return '/product-management';

    const permissions = JSON.parse(localStorage.getItem('userPermissions') || '[]');
    if (!permissions.length && !roles.length) return null;

    for (const entry of PERMISSION_ROUTES) {
        if (permissions.includes(entry.permission)) return entry.path;
    }
    return '/order-management';
}

export function getUserType() {
    const isAdmin = localStorage.getItem('isAdmin') === 'true';
    if (isAdmin) return 'admin';

    const roles = JSON.parse(localStorage.getItem('userRoles') || '[]');
    if (roles.includes('admin')) return 'admin';
    if (roles.length > 0) return 'team_member';

    return 'customer';
}
